import styled from "styled-components";

export const SecondaryTextLg = styled.div`
  font-size: 20px;
  font-weight: 400;
  color: ${window?.settings?.secondary_color ?? '#04333b'};
`;